import React from "react";
import { Logo } from "./logo";
import { NavItem } from "./nav-item";
import {
    Home,
    CalendarRange,
    Angry,
    FileUser,
    Ticket,
    ScrollText,
    UserPlus,
    AlertTriangle,
    KeyRound,
} from "lucide-react";

import {
    ADMIN_PATH,
    MANAGE_FIGHTER_REQUESTS_PATH,
    LOGIN_PATH,
    MANAGE_EVENTS_PATH,
    MANAGE_FIGHTERS_PATH,
    MANAGE_LIVE_STREAM_TICKETS_PATH,
    MANAGE_ORDERS_PATH,
    CREATE_FIGHTER_ACCOUNT_PATH,
    ERROR_LOGS_PATH,
    PARTNER_API_PATH,
} from "../App";
import { signOut } from "firebase/auth";
import { auth } from "../utils/firebase";
import { useLocation, useNavigate } from "react-router-dom";
import usePendingProfileUpdates from "../hooks/use-pending-profile-updates";

export default function NavBar() {
    const navigate = useNavigate();

    const location = useLocation();

    const pendingProfileUpdates = usePendingProfileUpdates();

    const navItems = (
        <>
            <NavItem title="Home" icon={<Home />} to={ADMIN_PATH} />
            <NavItem
                title="Fighter Requests"
                icon={<FileUser />}
                to={MANAGE_FIGHTER_REQUESTS_PATH}
                badge={pendingProfileUpdates}
            />
            <NavItem
                title="Fighter"
                icon={<Angry />}
                to={MANAGE_FIGHTERS_PATH}
            />
            <NavItem
                title="Event"
                icon={<CalendarRange />}
                to={MANAGE_EVENTS_PATH}
            />
            <NavItem
                title="Ticket"
                icon={<Ticket />}
                to={MANAGE_LIVE_STREAM_TICKETS_PATH}
            />
            <NavItem
                title="Order"
                icon={<ScrollText />}
                to={MANAGE_ORDERS_PATH}
            />
            <NavItem
                title="Create Account"
                icon={<UserPlus />}
                to={CREATE_FIGHTER_ACCOUNT_PATH}
            />
            <NavItem
                title="Error Logs"
                icon={<AlertTriangle />}
                to={ERROR_LOGS_PATH}
            />
            <NavItem
                title="Partner API"
                icon={<KeyRound />}
                to={PARTNER_API_PATH}
            />
        </>
    );

    let title = "";
    switch (location.pathname) {
        case ADMIN_PATH:
            title = "Home";
            break;
        case MANAGE_FIGHTER_REQUESTS_PATH:
            title = "Fighter Requests";
            break;
        case MANAGE_FIGHTERS_PATH:
            title = "Fighter";
            break;
        case MANAGE_EVENTS_PATH:
            title = "Event";
            break;
        case MANAGE_LIVE_STREAM_TICKETS_PATH:
            title = "Ticket";
            break;
        case MANAGE_ORDERS_PATH:
            title = "Order";
            break;
        case CREATE_FIGHTER_ACCOUNT_PATH:
            title = "Create Account";
            break;
        case ERROR_LOGS_PATH:
            title = "Error Logs";
            break;
        case PARTNER_API_PATH:
            title = "Partner API";
            break;
        default:
            title = "MFL";
            break;
    }
    return (
        <>
            <div className="flex flex-row md:flex-col items-center md:sticky md:h-screen top-0 left-0 p-4 bg-inherit overflow-visible md:overflow-y-auto scrollbar-hide">
                <div className="hidden md:block h-[48px]">
                    <NavItem
                        title="Home"
                        icon={<Logo h={48} w={48} />}
                        to={"/"}
                        className={"p-2 btn-link w-16 !border-0"}
                    />
                </div>
                <Logo className={"py-0 h-6 w-auto block md:hidden pt-1"} />
                <div className="dropdown inline-block md:hidden px-4">
                    <div
                        tabIndex={0}
                        role="button"
                        className="btn btn-square bg-base-100 shadow-none border-none"
                    >
                        <p className="font-bold mx-4 text-lg">{title}</p>
                    </div>
                    <ul
                        tabIndex={0}
                        className="dropdown-content z-[100] menu p-2 shadow bg-base-100 rounded-box w-52"
                    >
                        {navItems}
                    </ul>
                </div>

                <div className="hidden md:flex divider m-0" />
                <div className="hidden md:flex flex-1 md:flex-none" />
                <div className="hidden md:flex flex-row md:flex-col gap-4 overflow-x-visible overflow-y-visible scrollbar-hide">
                    {navItems}
                </div>
                <div className="flex-1 min-h-10" />
                <div className="divider m-0" />
                <button
                    className="btn btn-sm btn-outline btn-error md:w-full"
                    onClick={async () => {
                        await signOut(auth);
                        navigate(LOGIN_PATH);
                    }}
                >
                    Logout
                </button>
            </div>
        </>
    );
}
